import { render, staticRenderFns } from "./AddCard.vue?vue&type=template&id=a1773c9c&scoped=true"
import script from "./AddCard.vue?vue&type=script&lang=js"
export * from "./AddCard.vue?vue&type=script&lang=js"
import style0 from "./AddCard.vue?vue&type=style&index=0&id=a1773c9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1773c9c",
  null
  
)

export default component.exports